import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import SubcontractorsPage from "@/pages/admin/SubcontractorsPage";

export const Route = createFileRoute("/_admin/admin/subcontractors/")({
  head: () => pageHead("Admin · Subcontractors", "AKIVA admin · subcontractors portal.", "/admin/subcontractors", true),
  component: SubcontractorsPage,
});
